/* eslint-disable react/jsx-props-no-spreading */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Column, Container, Row } from '@iag-packages/chroma-react/lib/layouts';

import THEME from 'theme';
import { SCREEN } from 'scenes/common/types/screen';
import { isCarCampaign } from 'scenes/motor/helpers/campaign';

import MarketingCampaignBannerContent from './MarketingCampaignBannerContent';
import { MarketingCampaignCardProps } from '../types';

const CardContainer = styled.div`
  padding: 1em 0;
  background-color: ${THEME.BACKGROUND.CARD};

  @media (max-width: ${SCREEN.EXTRA_SMALL}px) {
    padding: 0;
  }

  @media (min-width: ${SCREEN.SMALL}px) and (max-width: ${SCREEN.LARGE}px) {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  @media (max-width: ${SCREEN.LARGE}px) {
    padding-left: 1rem;
  }
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-flow: wrap;

  .c-btn--link {
    color: ${THEME.LINK.ACCESSIBLE} !important;
  }

  @media (max-width: ${SCREEN.EXTRA_SMALL}px) {
    min-height: 5rem;
  }
`;

const DiscountCover = styled.img`
  position: relative;
  left: -1px;
  height: 52px;
  width: 52px;
  margin-right: 0.45em;
`;

export const HeaderMarketingCampaign: FunctionComponent<MarketingCampaignCardProps> = ({
  headerText,
  subText,
  termsLinkText,
  setIsModalOpen,
  imageUrl,
  campaign,
  shouldShowHeaderText = true,
}) => (
  <CardContainer>
    <Container>
      <Row>
        <Column xs={12} md={6} mdOffset={3}>
          <InnerContainer>
            <DiscountCover
              src={imageUrl}
              tabIndex={-1}
              alt="Discount cover graphic"
              aria-hidden
            />
            <div style={{ maxWidth: '80%' }}>
              <MarketingCampaignBannerContent
                text={headerText}
                subText={subText}
                shouldShowHeaderText={shouldShowHeaderText}
                onClick={setIsModalOpen}
                exclusions={isCarCampaign(campaign?.id ?? '')}
                termsLinkText={termsLinkText}
              />
            </div>
          </InnerContainer>
        </Column>
      </Row>
    </Container>
  </CardContainer>
);

export default HeaderMarketingCampaign;
